(function ($) {
    var elts = [];
    var items = [];
    var infobox;
    var rosace;
    var that;
    var settings;

    $.fn.euroviaRosace = function (options) {
        // Establish our default settings
        settings = $.extend({
            data: [],
            color: '#fff',
            pointFocus: 4,
            mode: "ajax",
            radius: 10,
            width: 500,
            height: 500,
            fontSize: 10,
            fontFamily: "Arial, Helvetica, sans-serif",
            pointRadius: 5,
            pointFillColor: '#fff',
            welcomeText: "",
        }, options);

        return this.each(function () {
            that = this;

            var id = $(that).attr('id');
            var nbPoints = settings.data.length;
            var step = 2 * Math.PI / nbPoints;

            if (settings.width == "full") {
                settings.width = $(that).width();
                settings.height = $(that).height();
                //console.log(settings.height);
                //console.log(settings.width);
                //console.log(settings.radius + " // " + (settings.radius * 2));
            }

            if (settings.data.length > 0) {
                var paper = Raphael(id, settings.width, settings.height);
                rosace = paper.circle(settings.width / 2, settings.height / 2, settings.radius).attr({ stroke: settings.color });
                infobox = new Infobox(paper, { x: settings.width / 2 - settings.radius, y: settings.height / 2 - settings.radius, width: settings.radius * 2, height: settings.radius * 2, rounding: 60, color: settings.color });
                infobox.div.addClass("infobox");
                infobox.div.css("font-family", settings.fontFamily);
                //infobox.div.css("position", "relative");
                var top = $("#rosace").height() / 2 - 10;

                infobox.div.css("top", top + "px");
                //infobox.div.css("left", ((settings.width - settings.radius) / 2) + "px");
                infobox.addHtml(settings.welcomeText);

                //Place points
                $.each(settings.data, function (idx, obj) {
                    var width = 250;
                    var angle = Math.PI - step * idx;
                    var x = Math.round(settings.width / 2 + settings.radius * Math.cos(angle));
                    var y = Math.round(settings.height / 2 + settings.radius * Math.sin(angle));

                    //DRAWING...
                    var circle = paper.circle(x, y, settings.pointRadius).attr({ fill: settings.pointFillColor, title: obj.title, stroke: settings.pointFillColor });
                    circle.node.setAttribute("class", "Pointer");
                    //var t = paper.text(x, y, obj.title).attr({ "font-size": settings.fontSize, "font-family": settings.fontFamily, fill: settings.color });
                    var t = new Infobox(paper, { x: x, y: y, width: width, height: 40, rounding: 0, color: settings.color });

                    t.addHtml(obj.title);

                    $(t.div).css({
                        "overflow": "hidden",
                        "width": "auto",
                        "font-size": "1.5em"
                    });

                    $(t.div).css("top", $(t.div).position().top - 143)

                    var shown = $(t.div).children().first();
                    shown.css({
                        "text-overflow": "ellipsis",
                        "white-space": "nowrap",
                        "overflow": "hidden",
                        "width": width + "px",
                        "display": "inline-block"
                    });

                    $(t.div).attr("data-url", obj.url);
                    $(t.div).attr("data-idx", idx);
                    $(t.div).attr("id", obj.id);
                    $(t.div).attr("class", "rosaceLink node");

                    //COMPUTE OFFSET NEEDS
                    var offsetX = offsetY = 0; var textWidth = $(t.div).children().first().textWidth();

                    if (angle < Math.PI / 4 && angle >= 0) {
                        offsetX = 25;
                    } else if (angle < Math.PI / 2 && angle >= Math.PI / 4) {
                        offsetX = 25; offsetY = 5;
                    } else if (angle < 3 * Math.PI / 4 && angle >= Math.PI / 2) {
                        offsetX = -width - 40; offsetY = 0;
                        $(t.div).attr("data-move", "true").css("text-align", "right");
                    } else if (angle < Math.PI && angle >= 3 * Math.PI / 4) {
                        offsetX = -width - 35; offsetY = -8;
                        $(t.div).attr("data-move", "true").css("text-align", "right");
                    } else if (angle < 5 * Math.PI / 4 && angle >= Math.PI) {
                        offsetX = -width - 40; offsetY = -8;
                        $(t.div).attr("data-move", "true").css("text-align", "right");
                    } else if (angle < 3 * Math.PI / 2 && angle >= 5 * Math.PI / 4) {
                        offsetX = -width; offsetY = -5;
                        $(t.div).attr("data-move", "true").css("text-align", "right");
                    } else if (angle < 3 * Math.PI / 2 && angle >= 5 * Math.PI / 4) {
                        console.log("5pi/4 modified !");
                        offsetX = -width - 5; offsetY = 5;
                        $(t.div).attr("data-move", "true").css("text-align", "right");
                    } else if (angle < 7 * Math.PI / 4 && angle >= 3 * Math.PI / 2) {
                        offsetX = 5; offsetY = 10;
                    } else if (angle < 2 * Math.PI / 4 && angle >= 7 * Math.PI / 4) {
                        offsetX = 5; offsetY = 5;
                    } else if (angle < 0 && angle >= -1) {
                        offsetX = 25; offsetY = -8;
                    } else if (angle < -1 && angle >= -1.5) {
                        offsetX = 25; offsetY = -15;
                    } else if (angle < -1.5 && angle >= -2) {
                        offsetX = -width; offsetY = -30;
                        $(t.div).attr("data-move", "true").css("text-align", "right");
                    } else if (angle < -2 && angle >= -3) {
                        offsetX = -width - 45; offsetY = -8;
                        $(t.div).attr("data-move", "true").css("text-align", "right");
                    }

                    if (angle <= -1.5 && angle >= -1.8) {
                        offsetX = textWidth < width ? -textWidth / 2 : -width / 2;
                        offsetY = -40;
                        $(t.div).removeAttr("data-move").css("text-align", "left");
                    }

                    if (angle >= 1.5 && angle <= 1.8) {
                        offsetX = textWidth < width ? -textWidth / 2 : -width / 2;
                        offsetY = 30;
                        $(t.div).removeAttr("data-move").css("text-align", "left");
                    }

                    //t.addHtml("angle = " + angle);
                    //t.addHtml(obj.title);
                    $(t.div).css('transform', 'translate(' + offsetX + 'px, ' + offsetY + 'px)');

                    var nWidth = 550;
                    //PUSH TO STORE
                    items[obj.id] = {
                        id: obj.id,
                        pLeft: parseInt($(t.div).css("left").replace("px", "")),
                        needMove: $(t.div).children().first().textWidth() > $(t.div).width() && typeof $(t.div).attr("data-move") != "undefined",
                        width: $(t.div).width(),
                        textWidth : $(t.div).children().first().textWidth(),
                        delta: parseInt($(t.div).css("left").replace("px", "")) + $(t.div).children().first().width() - nWidth,
                        needExpand: $(t.div).children().first().textWidth() > $(t.div).width(),
                        click: function () {
                            $(t.div).click();
                        }
                    };

                    //EVENTS
                    $(t.div).mouseover(function (e) {
                        $(t.div).children().first().clearQueue();
                        $(t.div).clearQueue();
                        if (items[obj.id].needMove) {
                            $(t.div).velocity({ "left": items[obj.id].delta + "px" });
                        }
                        if (items[obj.id].needExpand) {
                            $(t.div).children().first().velocity({ "width": nWidth + "px" });
                        }

                        circle.animate({ r: settings.pointRadius + settings.pointFocus });
                    });

                    $(t.div).mouseout(function (e) {
                        $(t.div).children().first().clearQueue();
                        $(t.div).clearQueue();
                        if (items[obj.id].needMove) {
                            $(t.div).velocity({ "left": items[obj.id].pLeft + "px" });
                        }

                        if (items[obj.id].needExpand) {
                            $(t.div).children().first().velocity({ "width": items[obj.id].width + "px" });
                        }

                        circle.animate({ r: settings.pointRadius });
                    });

                    circle.mouseover(function (e) {
                        $(t.div).children().first().clearQueue();
                        $(t.div).clearQueue();
                        if (items[obj.id].needMove) {
                            $(t.div).velocity({ "left": items[obj.id].delta + "px" });
                        }
                        if (items[obj.id].needExpand) {
                            $(t.div).children().first().velocity({ "width": nWidth + "px" });
                        }

                        circle.animate({ r: settings.pointRadius + settings.pointFocus });
                    });

                    circle.mouseout(function (e) {
                        $(t.div).children().first().clearQueue();
                        $(t.div).clearQueue();
                        if (items[obj.id].needMove) {
                            $(t.div).velocity({ "left": items[obj.id].pLeft + "px" });
                        }

                        if (items[obj.id].needExpand) {
                            $(t.div).children().first().velocity({ "width": items[obj.id].width + "px" });
                        }

                        circle.animate({ r: settings.pointRadius });
                    });

                    $(t.div).click(function (e) {
                        FocusElt1(t.div);

                        rosace.attr("fill", "rgba(255,255,255,0.2)");

                        if (settings.mode == "ajax") {
                            ProcessAjax(this);
                        } else if (settings.mode == "json") {
                            ProcessJson(this);
                        }
                    });

                    //circle.click(function (e) {
                    //    FocusElt1(t.node);
                    //    if (settings.mode == "ajax") {
                    //        ProcessAjax(t.node);
                    //    } else if (settings.mode == "json") {
                    //        ProcessJson(t.node);
                    //    }
                    //});

                    elts["#" + obj.id] = t;
                });

                //GESTION URL HASH
                var hash = window.location.hash.replace("#", "");

                if (hash != "") {
                    console.log("hash = " + hash);
                    console.log(items[hash]);
                    var obj = elts["#" + hash];
                    items[hash].click();
                }
            }
        });
    }

    function FocusElt1(obj) {
        $(".node").each(function (idx, node) {
            $(node).removeClass("currentRL");
        });

        $(obj).addClass("rosaceLink node currentRL");
    }

    function ProcessAjax(obj) {
        var url = $(obj).attr('data-url');

        $.ajax({
            url: url,
            success: function (data) {
                console.log(data);
                if (data == "") {
                    infobox.addHtml(settings.welcomeText);
                } else {
                    infobox.addHtml(data);
                }
            },
            error: function (data) {
                infobox.addHtml("ERROR CROSS DOMAIN");
                //infobox.addHtml("<a href=''>toto</a><br /><a href=''>toto</a><br /><a href=''>toto</a><br /><a href=''>toto</a><br />");
            }
        });
    }

    function ProcessJson(obj) {
        var idx = $(obj).attr('data-idx');
        if (settings.data[idx].externalLink != "") {
            window.open(settings.data[idx].externalLink);
            return false;
        } else {
            var data = settings.data[idx].children;
            if (data.length > 0) {
                var html = "";

                $(data).each(function (i, item) {
                    html += "<a href='" + item.url + "'>" + item.title + "</a><br />";
                });
                if (html == "") {
                    infobox.addHtml(settings.welcomeText);
                    window.location.href = settings.data[idx].url;
                } else {
                    infobox.addHtml(html);
                }
            } else {
                infobox.addHtml(settings.welcomeText);
                window.location.href = settings.data[idx].url;
            }
        }
    }

    /*function SetRosaceBg(img) {
		console.log(img);
		if(img) {
			rosace.attr({'fill': 'url('+img+')'});
		} else {
			rosace.attr({'fill': 'transparent'});
		}
	}*/

    $.fn.textWidth = function (text, font) {
		var org = $(this)
		var html = $('<span style="postion:absolute;width:auto;left:-9999px">' + (text || org.html()) + '</span>');
		if (!text) {
			html.css("font-family", org.css("font-family"));
			html.css("font-size", org.css("font-size"));
		}
		$('body').append(html);
		var width = html.width();
		html.remove();
		return width;
    };
}(jQuery));